import { Flex, Icon, Spacing, Switch, Text, Tooltip } from '@billy/design-system'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface PartialOrOverPaymentSwitchProps {
  isPartialOrOverPayment: boolean
  handlePartialOrOverPaymentChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const PartialOrOverPaymentSwitch = ({
  isPartialOrOverPayment,
  handlePartialOrOverPaymentChange,
}: PartialOrOverPaymentSwitchProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="row" justifyContent="center" alignItems="center" gap={Spacing.S8}>
      <Switch checked={isPartialOrOverPayment} onChange={handlePartialOrOverPaymentChange}>
        <Text>{t('subject.payment_reconcile.cross_currency.section.title')}</Text>
      </Switch>
      <Tooltip label={t('subject.payment_reconcile.cross_currency.tooltip')} placement="bottom">
        <Icon icon="info" />
      </Tooltip>
    </Flex>
  )
}
